export default {
  "debug": false,
  "dsn": "4ivlJULL9IxwppNMwjZx4CVUvvI"
}